<template>
    <div class="background">
    <b-img class="logo" src="/img/MVP_Logo.png" alt="MVP Logo" width="650" />
     <!-- <InventoryHome /> -->
    <div>
        <div class="cstmContainer" style="position: relative">
          <b-container>

            <!-- <h1 class="title">FOR THOSE WHO VALUE COMMUNITY</h1> -->
            <h2 class="subtitle">IN SOUTH BARRIE AT MAPLEVIEW DRIVE E. &amp; 20TH SIDEROAD</h2>
            <h3 class="text-orange">
              <!-- PHASE 1 SOLD OUT <br> REGISTER NOW FOR PHASE 2 -->
              <!-- <span style="text-decoration: underline; cursor: pointer" v-b-modal.registerModal>Register</span> For Our Next Release -->
            </h3>
            <!-- <h5 class="text-orange">
              NEW HOMES FROM THE HIGH $500’S
            </h5> -->
            <div>
              <b-row>
                <b-col offset-md="3" md="6">
                  <!-- https://player.vimeo.com/video/368894411?title=0&byline=0&portrait=0&transparent=0 -->
                  <a data-fancybox="video" href="/video/Guidelines-Fernbrook-MVP.mp4" class="video-btn"> WATCH VIDEO </a>
                </b-col>
              </b-row>
            </div>

            <!-- <h3 class="">
              <a data-fancybox="video" href="https://player.vimeo.com/video/368894411?title=0&byline=0&portrait=0&transparent=0" style="color:#28ace2">WATCH VIDEO</a>
            </h3>              -->
            <!-- <p>
              Mapleview Park is an all-new community of over 900 family homes in South Barrie. Located just minutes from the shores of
              Lake Simcoe’s Kempenfelt Bay, homeowners will be able to enjoy the peace and serenity that comes with lakeside living,
              along with the lively city vibe and convenience that downtown Barrie brings.
            </p>
            <h5>
              TOWNHOMES FROM $449,990<br>
              DETACHED HOMES WITH 2-CAR GARAGE FROM $549,990
            </h5>-->
            <!-- <b-row class="landingpageImage pt-1 pb-5"> -->
            <!-- <b-row class="landingpageImage" style="height:142px;position:relative;"> -->
            <!-- <b-col>
                <b-img src="/img/landingpage-img-1.png" width="375" />
                <b-img src="/img/landingpage-img-2.png" width="375" />
              </b-col>-->
            <!-- <b-col sm="4" offset-sm="4">
                <div class="flip-card hoverToFlip">
                  <div class="flip-card-inner">
                    <div class="flip-card-front">
                      <b-img src="/img/landingpage-img-new.png" width="375" />
                    </div>
                    <div class="flip-card-back">
                      <h1 class="text-uppercase mobileFontSize">
                        Floor plans<br> coming soon !
                      </h1>
                    </div>
                  </div>
                </div>
              </b-col> -->
            <!-- <b-col sm="4" offset-sm="2">
                <div class="flip-card hoverToFlip">
                  <div class="flip-card-inner">
                    <div class="flip-card-front">
                      <b-img src="/img/landingpage-img-1.png" width="375" />
                    </div>
                    <div class="flip-card-back">
                      <h1>Floor plans coming soon !</h1>
                    </div>
                  </div>
                </div>
              </b-col> -->
            <!-- <b-col sm="4">
                <div class="flip-card hoverToFlip">
                  <div class="flip-card-inner">
                    <div class="flip-card-front">
                      <b-img src="/img/landingpage-img-2.png" width="375" />
                    </div>
                    <div class="flip-card-back">
                      <h1>Floor plans coming soon !</h1>
                    </div>
                  </div>
                </div>
              </b-col> -->
            <!-- </b-row> -->
            <!-- <h5
              style="color:#F9AE43;"
              class="pt-0 pt-sm-4"
            >
              REDISCOVER THE THINGS YOU VALUE MOST IN BARRIE
            </h5> -->
            <!-- <h5 v-scroll-to="'#introTextNewSection'" style="color:#F9AE43;">
              LEARN MORE
            </h5>-->
            <div v-scroll-to="'#introTextNewSection'" class="bounce p-3">
              <b-img src="/img/downArrow.png" width="50" />
            </div>
            <h5 style="color: #f9ae43; color: #f9ae43; font-size: 24px; font-weight: 400" class="pt-3 pt-sm-4 mb-4">
              Live where you play &amp; re-discover the things you value most.
            </h5>

            <!-- <h2 id="introTextNewSection" class="introTextNewSection">
              REDISCOVER THE THINGS YOU
              <br>VALUE MOST AT MVP
            </h2> -->
          </b-container>
          
        </div>
      </div>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.carousel-indicators {
  z-index: 999;
  [data-bs-target] {
    width: 20px;
    height: 20px;
    opacity: 10;
    background-color: #d2d2d2;
  }
  .active {
    background-color: #f05b2d;
  }
}

.text-orange {
  color: #f05b2d !important;
}
.video-btn {
  font-family: "Gotham";
  border: 1px solid #2ba8e0;
  color: #2ba8e0;
  width: 100%;
  display: block;
  padding: 10px;
  margin: 15px;
  font-size: 20px;
  font-weight: 700;
}
.landingpageImage {
  .hoverToFlip:hover .flip-card-inner {
    transform: rotateY(180deg);
    // transition: all 1s ease;
  }
  // .hoverToFlip .flip-card-inner {
  //   transition-delay: 3s;
  //   -webkit-transition-delay: 3s;
  //   transition-duration: 1s;
  //   -webkit-transition-duration: 1s; /* Safari */
  // }
  .flip-card-inner {
    box-shadow: none;
  }
  .flip-card-back {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    background-color: #f05b2d;
    h1 {
      color: white;
      font-size: 1.5rem;
      @media screen and (min-width: 1320px) {
        font-size: 2.25rem;
      }
    }
  }
  .flip-card-front {
    img {
      width: 100%;
    }
  }
}

.slick-next,
.slick-prev {
  &:before {
    content: "" !important;
  }
}
.slick-next {
  right: 30px !important;
  background: url("/img/slick-next.png") !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  height: 40px !important;
  width: 40px !important;
}
.slick-prev {
  left: 30px !important;
  z-index: 10;
  background: url("/img/slick-prev.png") !important;
  background-repeat: no-repeat !important;
  background-size: contain !important;
  height: 40px !important;
  width: 40px !important;
}
.slick-dots li {
  position: relative;
  display: inline-block;
  width: 12px;
  height: 6px;
  margin: 0 5px;
  padding: 0;
  cursor: pointer;
}
.slick-dots li button {
  display: none;
}
.slick-dots li:before {
  top: 1px;
  transition: all 0.5s;
  content: "" !important;
  width: 16px;
  height: 16px;
  background-color: #bbbdbf;
  position: absolute;
}
.slick-dots li.slick-active:before {
  content: "" !important;
  top: 0;
  width: 18px;
  height: 18px;
  margin-left: -2px;
  background-color: #f05b2d;
}
.slick-dots li button:before,
.slick-dots li button:before {
  content: "" !important;
}
a:hover {
  text-decoration: none;
}
.background {
  width: calc(100% - 50px);
  margin: 25px;
  background-color: #f1f1f1;
}
.cstmContainer {
  flex-direction: column;
  margin: 20px auto;
  // min-height: calc(100vh);
  display: flex;
  justify-content: center;
  align-items: center;
  /* text-align: center; */
  .cstmWidth {
    width: 60%;
  }
}

.title {
  display: block;
  font-weight: bold;
  font-size: 50px;
  letter-spacing: 1px;
}

.subtitle {
  font-weight: 300;
  font-size: 25px;
  word-spacing: 5px;
  padding-bottom: 15px;
}

.introTextNewSection {
  font-weight: normal;
  width: 100%;
  color: #f9ae43;
  position: absolute;
  bottom: 15px;
  left: 0px;
  padding-top: 50px;
  @media screen and (max-width: 768px) {
    font-size: 18px;
  }
}
@media screen and (max-height: 568px) {
  .introTextNewSection {
    position: inherit;
    padding-top: 30px;
  }
  .bounce {
    display: none;
  }
}

.links {
  padding-top: 15px;
}

.topRightCross {
  font-size: 40px;
  color: #f9ae43;
  position: absolute;
  top: 10%;
  right: 5%;
  padding: 0px;
  margin: 0px;
  z-index: 20;
}

.register_container {
  position: relative;
  .btn_register {
    border-radius: 0;
    background-color: #f05b2d;
    // position: absolute;
    position: fixed;
    cursor: pointer;
    // right:15px;
    right: -66px;
    top: 15%;
    @media screen and (max-height: 768px) {
      top: 110px;
    }
    @media screen and (max-width: 576px) {
      right: -55px;
    }
    color: #fff;
    // border: 2px solid #f9ae43;
    font-size: 0.8rem;
    letter-spacing: 1px;
    padding: 15px 35px;
    font-family: "Gotham", sans-serif;
    font-size: 18px;
    font-weight: bold;
    z-index: 1032;
    &:hover {
      background-color: white;
      color: #f9ae43;
      border: 2px solid #f9ae43;
    }
    @media screen and (max-width: 576px) {
      font-size: 0.5rem;
    }
    -webkit-transform: rotate(-90deg);
    -moz-transform: rotate(-90deg);
    -o-transform: rotate(-90deg);
    -ms-transform: rotate(-90deg);
    transform: rotate(-90deg);
  }
}
.downArrow {
  position: absolute;
  bottom: -3%;
  left: calc(50% - 25px);
  padding: 0px;
  margin: 0px;
}

.bounce {
  -moz-animation: bounce 3s infinite;
  -webkit-animation: bounce 3s infinite;
  animation: bounce 3s infinite;
}
@media screen and (max-width: 812px), screen and (max-height: 812px) {
  .fp-section,
  .fp-tableCell {
    height: auto !important;
  }
  .downArrow {
    left: calc(50% - 12px);
    img {
      width: 25px;
    }
  }
  .logo {
    width: 250px;
  }
  .title {
    font-size: 25px !important;
  }
  .subtitle {
    font-size: 20px;
  }
  h5 {
    font-size: 15px;
  }
  p {
    font-size: 12px;
  }
  .cstmWidth {
    width: 90% !important;
  }
  .topRightCross {
    top: 0%;
    right: 15px;
    font-size: 30px;
  }
  .landingpageImage {
    img {
      width: 175px !important;
    }
    .flip-card-back {
      h1 {
        font-size: 25px;
      }
    }
  }
}
@-moz-keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

@-webkit-keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}

@keyframes bounce {
  0%,
  20%,
  50%,
  80%,
  100% {
    -moz-transform: translateY(0);
    -ms-transform: translateY(0);
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  40% {
    -moz-transform: translateY(-30px);
    -ms-transform: translateY(-30px);
    -webkit-transform: translateY(-30px);
    transform: translateY(-30px);
  }
  60% {
    -moz-transform: translateY(-15px);
    -ms-transform: translateY(-15px);
    -webkit-transform: translateY(-15px);
    transform: translateY(-15px);
  }
}
</style>
